export enum PointsOfInterestRoute {
  POINTS_OF_INTEREST_LIST = '/management-panel/points-of-interest',
  ADD_POINT_OF_INTEREST = '/management-panel/points-of-interest/add',
  IMPORT_RESULT = '/management-panel/points-of-interest/import',
  POINT_OF_INTEREST_CARD = '/management-panel/points-of-interest/:uuid',
  EDIT_POINT_OF_INTEREST = '/management-panel/points-of-interest/:uuid/edit',
}
